export default __webpack_public_path__ + "static/media/check.86305705.svg";